import React, { CSSProperties, ReactElement } from 'react';
import { Avatar } from '@material-ui/core';

export default function EventAvatar({ children, style = {} }: { children: ReactElement; style?: CSSProperties }) {
  return <Avatar style={Object.assign({ width: '24px', height: '24px' }, style)}>{children}</Avatar>;
}
